
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path opacity="0.4" d="M15.6364 3H2.64935C2.47713 3 2.31197 3.07107 2.19019 3.19759C2.06841 3.3241 2 3.49569 2 3.6746V5.69841C2.00004 5.87731 2.06847 6.04887 2.19026 6.17536L7.19481 11.3745V18.5159C7.19481 18.6412 7.22839 18.764 7.29179 18.8705C7.35518 18.9771 7.4459 19.0632 7.55376 19.1193C7.66162 19.1753 7.78237 19.199 7.90247 19.1877C8.02258 19.1765 8.13729 19.1307 8.23377 19.0556L10.8312 17.0317C10.9118 16.9689 10.9773 16.8874 11.0224 16.7938C11.0674 16.7001 11.0909 16.5968 11.0909 16.4921V11.3745L16.0955 6.17536C16.2172 6.04887 16.2857 5.87731 16.2857 5.69841V3.6746C16.2857 3.49569 16.2173 3.3241 16.0955 3.19759C15.9737 3.07107 15.8086 3 15.6364 3V3Z"></path><path d="M21.3507 6.85718H8.36365C8.19143 6.85718 8.02626 6.92825 7.90448 7.05476C7.78271 7.18128 7.71429 7.35286 7.71429 7.53178V9.55559C7.71433 9.73449 7.78277 9.90605 7.90455 10.0325L12.9091 15.2317V22.373C12.9091 22.4983 12.9427 22.6211 13.0061 22.7277C13.0695 22.8343 13.1602 22.9204 13.2681 22.9764C13.3759 23.0325 13.4967 23.0562 13.6168 23.0449C13.7369 23.0337 13.8516 22.9879 13.9481 22.9127L16.5455 20.8889C16.6261 20.8261 16.6916 20.7446 16.7366 20.6509C16.7817 20.5573 16.8052 20.454 16.8052 20.3492V15.2317L21.8097 10.0325C21.9315 9.90605 22 9.73449 22 9.55559V7.53178C22 7.35286 21.9316 7.18128 21.8098 7.05476C21.688 6.92825 21.5229 6.85718 21.3507 6.85718V6.85718Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiAflowmultiplefilterFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
